import React, { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { FormFooter } from '../FormFooter/FormFooter';
import { ModalBody } from '../../../../../CommonComponents/OPL/Modal/ModalBody';
import { useDeletePaymentMutation } from '../../../../api/useDeletePaymentMutation';
import { setIsOpen } from '../../../../state';
import { routeParamsSelector } from '../../../../../CommonComponents/Router/Selector';
import { Alert } from '../../../../../CommonComponents/OPL/Alert/Alert';

export const DisabledPayment: React.FC = () => {
  const { mutateAsync: deletePayment, isLoading, error } = useDeletePaymentMutation();

  const { clientId } = useSelector(routeParamsSelector);

  const dispatch = useDispatch();

  const handleSubmit = useCallback(
    async e => {
      e.preventDefault();

      try {
        await deletePayment(clientId);

        dispatch(setIsOpen(false));
      } catch {
        // Ignore
      }
    },
    [clientId, deletePayment, dispatch],
  );

  return (
    <form onSubmit={handleSubmit}>
      <ModalBody>{error && <Alert message={error.message} variant="error" my="16" />}</ModalBody>

      <FormFooter isLoading={isLoading} />
    </form>
  );
};
